'use strct';
import $ from 'jquery';

export default class Video {
	constructor() {

		if($('.video-block').length > 0){
			var $video = window.location.hash.substr(1),
				$newVideo = 'https://player.vimeo.com/video/' + $video;
			
			if(!$video == ''){
                $('iframe').attr('src',$newVideo);
            }
		}

		if($('.like').length > 0){
            
            // Which video does this btn belong to
            var  $id = $('.like').data('attribute'),
                $url = '/ajax-like/' + $id;
                
            // has this btn (id) been clicked true / false
            var $clicked = readCookie($id);
            
            if ($clicked == "true") {
                // disactivate if cookie [id]=true 
                $('.like').addClass('disabled active');
            } else {
                console.log('first time')
                $('.like').on('click',function(){
                    
                    var $cookie = $id + '=true'; // Btn now clicked [id]=true,
                    document.cookie = $cookie;   // Add value to cookie
                    
                    var $returnLikes = $.ajax({
                        type: 'POST',       
                        url: $url,
                        dataType: 'html',
                        context: document.body,
                        global: false,
                        async:false,
                        success: function(data) {
                            return data;
                        }
                    }).responseText;

                    $('.like').addClass('disabled active').next('.like-txt').text('x ' + $returnLikes);
                    
                })
            }

            // return cookie by name function
            function readCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for(var i=0;i < ca.length;i++) {
                    var c = ca[i];
                    while (c.charAt(0)==' ') c = c.substring(1,c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
                }
                return null;
            }
			
		}
	}
}